import { stringifyValues } from '@/lib/utils/queries'
import { getApi } from '@/stores/api'
import { useQuery } from '@tanstack/react-query'
import { AuditTrailsSearch } from '../useAuditTrails'

async function getAuditTrails(queries: AuditTrailsSearch, signal?: AbortSignal) {
  const api = getApi()
  const res = await api.crt['audit-trails'].$get(
    { query: stringifyValues(queries) },
    { init: { signal } },
  )

  const { auditTrails, count } = await res.json()
  return { auditTrails, count }
}

async function getAuditTrailById(id: number | undefined, signal?: AbortSignal) {
  const api = getApi()
  const res = await api.crt['audit-trails'][':id'].$get(
    { param: { id: String(id) } },
    { init: { signal } },
  )

  const { auditTrail } = await res.json()
  return auditTrail
}

export function useAuditTrails(queries: AuditTrailsSearch) {
  return useQuery({
    queryKey: ['crt-audit-trails', queries],
    queryFn: ({ signal }) => getAuditTrails(queries, signal),
  })
}

export function useAuditTrailById(id: number | undefined) {
  return useQuery({
    queryKey: ['crt-audit-trail', id],
    queryFn: ({ signal }) => getAuditTrailById(id, signal),
    enabled: Boolean(id),
  })
}
